// extracted by mini-css-extract-plugin
export default {"item":"ProjectTemplate_item__RkJDl","sampleImage":"ProjectTemplate_sampleImage__q-kbH"};